const obfuscate = item => {
    if (typeof item === 'object') {
        item = JSON.stringify(item);
    }

    item = item.replace(/a/g, '%Jx3b),');
    item = item.replace(/{/g, '[~r2L');
    item = item.replace(/:/g, 'Ap0Y|^');
    item = item.replace(/_/g, 'redacted*L16');
    item = item.replace(/~/g, 'd7:{a_');

    item = encodeURI(item);

    return item;
};

export default obfuscate;
